import { useQuery } from "@tanstack/react-query";

import type { ISiteTag } from "app/pages/sales-intelligence/domain/leads/types/website";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { leadsSearchFiltersQueryKeys } from "./queryKeyFactory";

const mapValidatedSiteTagsResponse = (response: readonly ISiteTag[]): string[] => response.map(({ tag }) => tag);

type UseSiteTagsBulkValidationQueryOptions = {
    readonly tags: readonly string[];
    readonly enabled?: boolean;
};

const useSiteTagsBulkValidationQuery = ({ tags, enabled = true }: UseSiteTagsBulkValidationQueryOptions) =>
    useQuery({
        enabled: enabled && tags.length > 0,
        queryKey: leadsSearchFiltersQueryKeys.siteTagsBulkValidation(tags),
        queryFn: ({ signal }) => salesApiService.validateBulkSiteTags(tags, { cancellation: signal }),
        select: mapValidatedSiteTagsResponse,
    });

export default useSiteTagsBulkValidationQuery;
